import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';


@Component({
  selector: 'app-taskdates',
  templateUrl: './taskdates.component.html',
  styleUrl: './taskdates.component.scss',
  standalone: true,
  imports: [CommonModule, FormsModule],
})
export class TaskdatesComponent {
  @Input() organizationKey: string = "";
  @Input() projectKey: string = "";
  @Input() userId: string = "";
  @Input() content: string = "";
  @Input() startDate: string = "";
  @Input() endDate: string = "";
  @Input() contentKey: string = "";
  @Output() valueChange = new EventEmitter<{startDate: string, endDate: string}>();

  onStartDateChange(event: any) {
    this.startDate = event
    this.valueChange.emit({startDate: this.startDate, endDate: this.endDate})
  }

  onEndDateChange(event: any) {
    this.endDate = event
    this.valueChange.emit({startDate: this.startDate, endDate: this.endDate})
  }
}
